import { distanceIntervaled } from "./common/intervaled.js";
import { locality as localityAt } from "../api/api.js";

const MINIMUM_DISTANCE_INTERVAL_METERS = 5000;

const locality = distanceIntervaled(
	MINIMUM_DISTANCE_INTERVAL_METERS,

	([$journey], set) => {
		if (!$journey.location) {
			return;
		}

		localityAt($journey.location)
			.then(({ locality }) => {
				set(locality);
			})
			.catch((error) => {
				console.warn("failed to determine locality", error.message);
			});
	}
);

export default locality;
